/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {useDispatch} from 'react-redux'
import {
  setDefaultParameters,
  setFavoriteApps,
  setFavoriteGroups,
  setRegisteredApps,
  setRegisteredModules
} from '../store/appsSlice'
import {Favorite, Group} from '../model/favorites'
import {useError, useResolver} from '@enisco/mcc-react-lib'
import {App, Module} from '../model/apps'

const useLoadProfile = (): [() => Promise<void>] => {
  const dispatch = useDispatch()
  const resolver = useResolver()
  const error = useError()

  const setter = async () => {
    await resolver('mcc-portal-api', '/internal/get-config', {
      options: {
        method: 'GET',
        headers: {'Content-Type': 'application/json'}
      }
    })
      .then((response: {json: () => any}) => response.json())
      .then((data) => {
        const appsLoaded = data.apps || []
        const modulesLoaded = data.modules || []
        const favoritesLoaded = data.favorites || []
        const groupsLoaded = data.groups || []
        const defaultParametersLoaded = data.defaultParameters || []

        dispatch(setDefaultParameters(defaultParametersLoaded))
        dispatch(setFavoriteApps(favoritesLoaded))
        groupsLoaded.forEach((group: Group) => {
          group.favorites = favoritesLoaded.filter(
            (fav: Favorite) => fav.groupId === group.id
          )
        })
        dispatch(setFavoriteGroups(groupsLoaded))

        dispatch(setRegisteredApps(appsLoaded))
        modulesLoaded.forEach((module: Module) => {
          module.apps = appsLoaded.filter(
            (app: App) => app.module === module.name
          )
        })
        dispatch(setRegisteredModules(modulesLoaded))
      })
      .catch(error)
  }

  return [setter]
}

export default useLoadProfile
